import { CreateProduct } from "@/types/product";
import axios from "./productInstance";


const createProduct = async (product: CreateProduct, id?: string | null): Promise<any | null> => {
    try {
        const response = id
            ? await axios.put(`/products/${id}`, product)
            : await axios.post(`/products/`, product);

        return response.data.id;
    } catch (error) {
        console.error("Error creating or updating the product:", error);
        return null;
    }
};

export default createProduct;
